import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'fil',
  months: [
    'Enero',
    'Pebrero',
    'Marso',
    'Abril',
    'Mayo',
    'Hunyo',
    'Hulyo',
    'Agosto',
    'Setyembre',
    'Oktubre',
    'Nobyembre',
    'Disyembre',
  ],
  monthsShort: ['Ene', 'Peb', 'Mar', 'Abr', 'May', 'Hun', 'Hul', 'Ago', 'Set', 'Okt', 'Nob', 'Dis'],
  weekdays: ['Linggo', 'Lunes', 'Martes', 'Miyerkules', 'Huwebes', 'Biyernes', 'Sabado'],
  weekdaysMin: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  weekdaysShort: ['Lin', 'Lun', 'Mar', 'Miy', 'Huw', 'Biy', 'Sab'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'MMMM D',
    LLL: 'MMMM D, YYYY, HH:mm',
    'LLL-Y': 'MMMM D, HH:mm',
    LLLL: 'dddd, MMMM D, YYYY, HH:mm',
    'LLLL-Y': 'dddd, MMMM D, HH:mm',
    l: 'M/D/YYYY',
    'l-Y': 'M/D',
    ll: 'MMM D, YYYY',
    'll-Y': 'MMM D',
    'll-D': 'MMM YYYY',
    lll: 'MMM D, YYYY, h:mm A',
    'lll-Y': 'MMM D, h:mm A',
    llll: 'ddd, MMM D, YYYY, h:mm A',
    'llll-Y': 'ddd, MMM D, h:mm A',
    'll-Y+w': 'ddd, MMM D',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'MMMM D, YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%sy ang nakalipas', other: '%sy ang nakalipas' },
    M: { one: '%smo ang nakalipas', other: '%smo ang nakalipas' },
    w: { one: '%sw ang nakalipas', other: '%sw ang nakalipas' },
    d: { one: '%sd ang nakalipas', other: '%sd ang nakalipas' },
    h: { one: '%sh ang nakalipas', other: '%sh ang nakalipas' },
    m: { one: '%sm ang nakalipas', other: '%sm ang nakalipas' },
    s: { one: '%ss ang nakalipas', other: '%ss ang nakalipas' },
  },
  future: {
    y: { one: 'sa %sy', other: 'sa %sy' },
    M: { one: 'sa %smo', other: 'sa %smo' },
    w: { one: 'sa %sw', other: 'sa %sw' },
    d: { one: 'sa %sd', other: 'sa %sd' },
    h: { one: 'sa %sh', other: 'sa %sh' },
    m: { one: 'sa %sm', other: 'sa %sm' },
    s: { one: 'sa %ss', other: 'sa %ss' },
  },
  pastLong: {
    y: { one: '%s taon ang nakalipas', other: '%s (na) taon ang nakalipas' },
    M: { one: '%s buwan ang nakalipas', other: '%s (na) buwan ang nakalipas' },
    w: { one: '%s linggo ang nakalipas', other: '%s (na) linggo ang nakalipas' },
    d: { one: '%s araw ang nakalipas', other: '%s (na) araw ang nakalipas' },
    h: { one: '%s oras ang nakalipas', other: '%s (na) oras ang nakalipas' },
    m: { one: '%s minuto ang nakalipas', other: '%s (na) minuto ang nakalipas' },
    s: { one: '%s segundo ang nakalipas', other: '%s (na) segundo ang nakalipas' },
  },
  futureLong: {
    y: { one: 'sa %s taon', other: 'sa %s (na) taon' },
    M: { one: 'sa %s buwan', other: 'sa %s (na) buwan' },
    w: { one: 'sa %s linggo', other: 'sa %s (na) linggo' },
    d: { one: 'sa %s araw', other: 'sa %s (na) araw' },
    h: { one: 'sa %s oras', other: 'sa %s (na) oras' },
    m: { one: 'sa %s minuto', other: 'sa %s (na) minuto' },
    s: { one: 'sa %s segundo', other: 'sa %s (na) segundo' },
  },
  abbr: {
    y: { one: '%sy', other: '%sy' },
    M: { one: '%smo', other: '%smo' },
    w: { one: '%sw', other: '%sw' },
    d: { one: '%sd', other: '%sd' },
    h: { one: '%sh', other: '%sh' },
    m: { one: '%sm', other: '%sm' },
    s: { one: '%ss', other: '%ss' },
  },
  full: {
    y: { one: '%s taon', other: '%s (na) taon' },
    M: { one: '%s buwan', other: '%s (na) buwan' },
    w: { one: '%s linggo', other: '%s (na) linggo' },
    d: { one: '%s araw', other: '%s (na) araw' },
    h: { one: '%s oras', other: '%s (na) oras' },
    m: { one: '%s minuto', other: '%s (na) minuto' },
    s: { one: '%s segundo', other: '%s (na) segundo' },
  },
  justNow: 'Ngayon lang',
  yesterday: 'Kahapon',
  today: 'Ngayong Araw',
  tomorrow: 'Bukas',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: { 'HH:mm': 'h:mm A' },
  timeRangeStyles: {
    yl: { start: 'MMMM D, YYYY', end: 'MMMM D, YYYY' },
    'yl-1': { start: 'MMMM D', end: 'MMMM D, YYYY' },
    ml: { start: 'MMMM D', end: 'MMMM D' },
    'ml-1': { start: 'MMMM D', end: 'D, YYYY' },
    dl: { start: 'MMMM D', end: 'D' },
    y: { start: 'MMM D, YYYY', end: 'MMM D, YYYY' },
    'y-1': { start: 'MMM D', end: 'MMM D, YYYY' },
    m: { start: 'MMM D', end: 'MMM D' },
    'm-1': { start: 'MMM D', end: 'D, YYYY' },
    d: { start: 'MMM D', end: 'D' },
    Y: { start: 'ddd, MMM D, YYYY', end: 'ddd, MMM D, YYYY' },
    'Y-1': { start: 'ddd, MMM D', end: 'ddd, MMM D, YYYY' },
    M: { start: 'ddd, MMM D', end: 'ddd, MMM D' },
    D: { start: 'ddd, MMM D', end: 'ddd, MMM D' },
    yt: { start: 'MMM D, YYYY, HH:mm', end: 'MMM D, YYYY, HH:mm' },
    mt: { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm' },
    dt: { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'MMM D, YYYY, HH:mm', end: 'MMM D, YYYY, HH:mm ([GMT]Z)' },
    'mt+to': { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm ([GMT]Z)' },
    'dt+to': { start: 'MMM D, HH:mm', end: 'MMM D, HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'fil';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
